import React from "react"

import { ThemeLayoutEnum } from "@/models/ITrackingPageOptions"

import ThemeLayoutLeftStyleBackdropTabPanel from "./ThemeLayoutLeftStyleBackdropTabPanel"
import ThemeLayoutLeftStyleShowcaseTabPanel from "./ThemeLayoutLeftStyleShowcaseTabPanel"

export interface ThemeLayoutLeftStyleTabPanelProps {
  variant: ThemeLayoutEnum
}

const ThemeLayoutLeftStyleTabPanel = ({ variant }: ThemeLayoutLeftStyleTabPanelProps) => {
  if (variant === ThemeLayoutEnum.BACKDROP) {
    return <ThemeLayoutLeftStyleBackdropTabPanel />
  }

  return <ThemeLayoutLeftStyleShowcaseTabPanel />
}

export default ThemeLayoutLeftStyleTabPanel
